const actions = {
  // send invites -----------------------------------------------------------
  async handleInviteUsersToSpaceByEmail({getters,dispatch}, {emails, areaId = getters.getCurrentAreaId}) {
    let res = await dispatch('api/nav/adminOfferSpaceAccess', {
      users: emails.map(e => ({email: e}) ),
      areaId
    });

    if (res.success) {
      const validAdds = res.success.filter(e => e.result == 'success')
      const invalidAdds = res.success.filter(e => e.result != 'success')

      dispatch('popups/settings/successInvitingUsersToArea', {
        validAdds,
        invalidAdds
      })
      dispatch('analytics/inviteUsersToSpace', [emails, validAdds, invalidAdds])

    } else {
      if(res.error && res.error.message === 'Invite email or user id must be set.') { //patch for can't reinvite converted guest bug
        dispatch('popups/settings/errorInvitingConvertedGuestUsersToArea')
      } else {
        dispatch('popups/settings/errorInvitingUsersToArea')
      }
    }
    return res.success

  },

  // respond to invites -----------------------------------------------------------
  async handleGetSpaceInviteData({dispatch}, token) {
    let res = await dispatch('api/nav/getInviteData', token)
    let data = res.success
    return data
  },

  async handleAcceptSpaceInvite({dispatch}, [token, space]) {
    let res = await dispatch('api/nav/acceptSpaceAccess', token)
    let data = res.success

    if (!data) { // still need to show specific error messages depending on res (ie mismatch email)
      dispatch('handleShowAreaInviteErrorPopup', data)
    } else {
      dispatch('routing/goToArea', space.areaId)
      dispatch('analytics/respondToSpaceInvite', ['accept', space])
    }
    return data
  },
  async handleRejectSpaceInvite({dispatch}, [token, space]) {
    let res = await dispatch('api/nav/rejectSpaceAccess', token)
    let data = res.success

    if (!data) { // still need to show specific error messages depending on res (ie mismatch email)
      dispatch('handleShowAreaInviteErrorPopup', data)
    } else {
      dispatch('routing/goToHome')
      dispatch('analytics/respondToSpaceInvite', ['reject', space])
    }
    return data
  },

  async handleShowAreaInviteResponsePopup({dispatch}, res) {
    let message = ''
    let icon = 'success'
    switch(res) {
      case 'invalid':
        message = 'Invite invalid.'
        icon = 'error'
        break
      case 'expired':
        message = 'Invite expired.'
        icon = 'error'
        break
      case 'emailMismatch':
        message = 'This invite was intended for someone else.'
        icon = 'error'
        break
    }
    if(message) dispatch('popups/nav/errorRespondingToAreaInvite', {icon, message})
  }
};

export default {
  actions
};
